import {connect} from 'react-redux';
import {withRouter} from 'react-router-dom';
import InputComponent from '../components/InputComponent';
import IAppState from '../../../IAppState';
import {IInputComponentPropsData, IInputComponentPropsFunctions} from '../props/IInputComponentProps';
import ActMain from "../../../act-main";
import ActSummary from "../../SummaryPage/state/act-summary";
import {clientUrlPrefix, exampleID} from '../../../settings';
import IDT from "../interfaces/InputDataType";
import { ll_fetch } from '../../../tools';
import IMainState from '../../../IMainState';
import ATE from '../../../ActionTypeEnum';

function submitInput(dispatch: any, browserHistory: any) {

    dispatch(ActSummary.submitInput());
    dispatch(ActMain.setResultsLoaded(false));

    browserHistory.push(clientUrlPrefix+"/job-setting");
}

async function obtainSequence(dispatch: any, jobId: string, specifyChainsManually: boolean, selectedMM: string, selectedChains: any, inputDataType: IDT, sequence:string) {

    if(inputDataType == 0){
        if(specifyChainsManually){
            await ll_fetch(`/api/pdb/processManualSelection?jobId=${jobId}&selectedChains=${selectedChains}`);
        }

        await ll_fetch(`/api/CataliticResidues/getFastaSequence?jobId=${jobId}&specifyChainsManually=${specifyChainsManually}&selectedMM=${selectedMM}`)
            .then((response) => response.text())
            .then((data) =>
                dispatch({
                    type: ATE.CHANGE_SEQUENCE_FIELD,
                    value: data.toUpperCase(),
                })
            )
            .catch((err) => {
                console.log('FAILED TO GET SEQUENCE');
                console.error(err);
        });
    }
    else{
        dispatch({
            type: ATE.CHANGE_SEQUENCE_FIELD,
            value: sequence.toUpperCase()
        });
    }

    await ll_fetch(`/api/CataliticResidues/getSequenceMapping?jobId=${jobId}&isStructure=${!inputDataType}&sequence=${sequence}`)
    .then((response) => response.json())
    .then((data) => dispatch({
        type: ATE.LOAD_INDEXES,
        value: data,
    }));
}

function redirectExample(browserHistory: any) {
    browserHistory.push(`${clientUrlPrefix}/job/${encodeURIComponent(exampleID)}`);
    location.href = `${clientUrlPrefix}/job/${encodeURIComponent(exampleID)}`;
}

interface IOwnProps {
    ecNumber?: string,choice
    customQuery?: boolean,
    history: any,
}

function testMessage() {
    ll_fetch(`/api/HelloApi`)
    .then(response => {
        if (response.ok) {
            // response.json()
            console.log(response.text())

        } else {
            console.log("error")
        }
    })
    .catch(err => {
        console.log("FAILED")
        console.error(err);
    })
}

const mapStateToProps = ({mainState}: IAppState, ownProps: IOwnProps): IInputComponentPropsData => {
    return {
        jobTitle: mainState.jobTitle,
        email: mainState.email,
        inputDataType: mainState.inputDataType,
        pdbIdField: mainState.pdbIdField,
        uniprotIdField: mainState.uniprotIdField,
        pdbChainField: mainState.pdbChainField,
        sequence: mainState.sequence,
        sPMutations: mainState.sPMutations,
        modelling: mainState.modelling,
        processedStructure: mainState.processedStructure,
        jobId: mainState.jobId,
        selectedMM: mainState.selectedStructureInfo !== null ? '' + mainState.selectedStructureInfo.molecule : "-1",
        selectedChains: mainState.selectedChains,
        specifyChainsManually: mainState.specifyChainsManually,
        sequenceChecked: mainState.sequenceChecked,
    }
};

const mapDispatchToProps = (dispatch: any, ownProps: IOwnProps): IInputComponentPropsFunctions => ({

    resetMainState: () => dispatch(ActMain.resetMainState()),

    changeInputDataType: (inputDataType: IDT) => dispatch(ActMain.changeInputDataType(inputDataType)),
    changejobTitle: (jobTitle: string) => dispatch(ActMain.changejobTitle(jobTitle)),
    changeemail: (email: string) => dispatch(ActMain.changeemail(email)),


    changePdbChainField : (pdbChainField: string ) => dispatch(ActMain.changePdbChainField(pdbChainField)),
    changePdbIdField : (pdbIdField: string ) => dispatch(ActMain.changePdbIdField(pdbIdField)),
    changesequence : (sequence: string ) => dispatch(ActMain.changesequence(sequence)),
    addRemoveMutation : (position: number, base: string ) => dispatch(ActMain.addRemoveMutation(position, base)),
    AddAllMutationsOnPosition : (position: number, base: string) => dispatch(ActMain.AddAllMutationsOnPosition(position, base)),
    toggleModelling : () => dispatch(ActMain.toggleModelling()),
    submitInput: () => submitInput(dispatch, ownProps.history),
    obtainSequence: (jobId: string, specifyChainsManually: boolean, selectedMM: string, selectedChains: any, inputDataType: IDT, sequence: string) => obtainSequence(dispatch, jobId, specifyChainsManually, selectedMM, selectedChains, inputDataType, sequence),

    setJobId : (jobId: string ) => dispatch(ActMain.setJobId(jobId)),

    redirectExample: () => redirectExample(ownProps.history),

    testMessage: () => testMessage(),
})


const InputContainer = withRouter(connect(
    mapStateToProps,
    mapDispatchToProps
)(InputComponent));

export default InputContainer;
